window.addEventListener('DOMContentLoaded', () => {
	try {
		var swiper = new Swiper('.swiper-container.custom_reviews', {
			slideToClickedSlide: true,
			nextButton: '.custom_reviews .swiper-button-next',
			prevButton: '.custom_reviews .swiper-button-prev',
			pagination: '.custom_reviews .swiper-pagination',
			slidesPerView : 2,
			breakpoints: {
				768 : {
					slidesPerView : 1
				}
			}
		});
	} catch (e) {
		console.error(e);
	}
});
